import React from 'react';
import { SuitDivider } from './SuitDivider';
export function Footer() {
  return <footer className="relative bg-deep-green pt-2 pb-12" data-id="element-38">
      <SuitDivider className="mb-10 max-w-lg mx-auto" data-id="element-39" />
      <div className="text-center px-6" data-id="element-40">
        <p className="font-display text-goldenrod/50 uppercase tracking-[0.3em] text-sm mb-3" data-id="element-41">
          Strategame
        </p>
        <p className="font-body text-ivory/40 text-sm" data-id="element-42">
          © 2026 Strategame. All rights reserved. EUR.
        </p>
      </div>
    </footer>;
}